import { createFileRoute } from '@tanstack/react-router';

import { LocalAccountBrowse } from '@/module/User/LocalAccountBrowse';

export const Route = createFileRoute('/_auth/administration/_administration/local-accounts/_local-accounts/')({
  component: RouteComponent,
});

function RouteComponent() {
  return <LocalAccountBrowse />;
}
